import { render } from "./ProductSelect.vue?vue&type=template&id=dad7a936&scoped=true&ts=true"
import script from "./ProductSelect.vue?vue&type=script&lang=ts"
export * from "./ProductSelect.vue?vue&type=script&lang=ts"

import "./ProductSelect.vue?vue&type=style&index=0&id=dad7a936&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dad7a936"]])

export default __exports__